export default __webpack_public_path__ + "static/media/3.455a8f5c.jpg";